import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';

interface StatusIndicatorProps {
  status: 'operational' | 'degraded' | 'down';
  label?: string;
  size?: 'small' | 'medium' | 'large';
  showIcon?: boolean;
}

export default function StatusIndicator({
  status,
  label,
  size = 'medium',
  showIcon = true,
}: StatusIndicatorProps) {
  const statusConfig = {
    operational: {
      color: '#2e7d32', // success green
      icon: <CheckCircleIcon />,
      label: 'Operational',
    },
    degraded: {
      color: '#ed6c02', // warning orange
      icon: <WarningIcon />,
      label: 'Degraded',
    },
    down: {
      color: '#d32f2f', // error red
      icon: <ErrorIcon />,
      label: 'Down',
    },
  };

  const config = statusConfig[status];
  const iconSize = size === 'large' ? 48 : size === 'medium' ? 32 : 24;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      {showIcon && (
        <Box
          sx={{
            color: config.color,
            display: 'flex',
            '& svg': {
              fontSize: iconSize,
            },
          }}
        >
          {config.icon}
        </Box>
      )}
      <Box>
        <Typography
          variant={size === 'large' ? 'h6' : 'body1'}
          sx={{ color: config.color, fontWeight: 600 }}
        >
          {label || config.label}
        </Typography>
      </Box>
    </Box>
  );
}
